/* eslint-disable no-unused-vars */
import React, { useEffect, useState } from "react";

import {
  Button,
  FormControl,
  Grid,
  TextField,
  Typography,
  Box,
  InputAdornment,
} from "@mui/material";

import Img from "../../assest/pic/login-form.png";
import logo from "../../assest/pic/logo1 1.png";
import { useNavigate } from "react-router-dom";

import Visibility from "@mui/icons-material/Visibility";
import VisibilityOff from "@mui/icons-material/VisibilityOff";
import { SelectComponent } from "../StyledComponent";
import { PopupModal } from "../CommonComponents/PopupModal";



function LoginComponent({
  title,
  discription,
  subTitle,
  handleSubmit,
  formValue,
  setFormValue,
  handleChange,
  rolesDropdown,
}) {
  const { password, email, role } = formValue;
  const options = [
    { name: "Super Admin", value: "Super Admin" },
    { name: "Admin", value: "Admin" },
    { name: "Manager", value: "Manager" },
    { name: "Senior Manager", value: "Senior_Manager" },
    { name: "BHU", value: "BHU" },
    { name: "Operations", value: "Operations" },
    { name: "Finance", value: "Finance" },
  ];

  const [showPassword, setShowPassword] = useState(false);
  const [isFinanceLogin, setIsFinanceLogin] = useState(false);
const [userModal, setUserModal] = useState(false);
console.log(rolesDropdown,'rolesDropdown')    
  const passwordToggle = () => setShowPassword((show) => !show);

  const naviagte = useNavigate();

  const resetPassword = () => {
    naviagte("/resetPassword");
  };

  useEffect(()=>{
    if(rolesDropdown.length > 0 && !rolesDropdown.includes("Finance")){
      setUserModal(true)
    }
    
  },[rolesDropdown])

  return (
    <Grid container sx={{ height: "100vh" }}>
      <Grid
        item
        md={6}
        xs={12}
        sx={{
          height: "100%",
          background: `url(${Img})`,
          backgroundSize: "100% 100%",
          position: "relative",
          "@media(max-width:900px)": {
            height: "45vh !important",
          },
        }}
      >
        <Grid
          container
          sx={{ justifyContent: "center", alignItems: "center" }}
          className="loginOverlay"
        >
          <Grid item sx={{ justifyContent: "center" }}>
            <Box component="img" src={logo} height="180px" />
            <Typography
              variant="body1"
              color="white"
              textAlign="center"
              mt="-25px"
              sx={{}}
            >
              Rental Portal
            </Typography>
          </Grid>
        </Grid>
      </Grid>

      <Grid
        item
        container
        md={6}
        xs={12}
        sx={{ justifyContent: "center", alignItems: "center" }}
      >
        <Grid item md={7} xs={11} sx={{ "@media(max-width:900px)": { mb: 2 } }}>
          <Typography
            variant="body1"
            fontSize="50px"
            lineHeight="70px"
            color="var(--main-color)"
            fontWeight="700 !important"
          >
            {title}
          </Typography>
          <Typography
            variant="body1"
            fontSize="16px"
            lineHeight="24px"
            color="#C8C8C8"
            sx={{
              "@media(max-width:900px)": {
                textAlign: "center",
              },
            }}
          >
            {discription}
          </Typography>

          <Box component="form" sx={{ mt: 2 }} onSubmit={handleSubmit}>
            <Grid container sx={{ justifyContent: "center" }} spacing={2}>
              <Grid item xs={12}>
                <FormControl sx={{ my: 1 }} fullWidth className="LoginInput">
                  <TextField
                    autoFocus={true}
                    style={{ border: "1px solid black" }}
                    variant="filled"
                    placeholder="Enter Email Address"
                    label="Email Address"
                    value={email}
                    name="email"
                    maxLength={50}
                    InputProps={{
                      disableUnderline: true,
                      style: {
                        fontSize: "18px",
                        paddingTop: "2px",
                      },
                    }}
                    onChange={handleChange}
                    required
                  />
                </FormControl>
              </Grid>

              <Grid item xs={12}>
                <FormControl fullWidth className="LoginInput">
                  <TextField
                    autoFocus={false}
                    style={{ border: "1px solid black" }}
                    type={showPassword ? "text" : "password"}
                    variant="filled"
                    placeholder="********"
                    label={"Password"}
                    value={password}
                    required
                    name="password"
                    onChange={handleChange}
                    InputProps={{
                      disableUnderline: true,
                      style: {
                        fontSize: "18px",
                        paddingTop: "2px",
                      },
                      endAdornment: (
                        <InputAdornment position="end" onClick={passwordToggle}>
                          {!showPassword ? <Visibility /> : <VisibilityOff />}
                        </InputAdornment>
                      ),
                    }}
                  />
                </FormControl>
                {rolesDropdown.length > 1 && (
                  <SelectComponent
                    fullWidth
                    sx={{ width: 1 / 2, pt: 2 }}
                    label={"Roles"}
                    required={true}
                    name="role"
                    options={rolesDropdown}
                    onChange={(e) => {
                      handleChange(e);
                    }}
                    role={true}
                  />
                )}
              </Grid>

              <Grid item xs={12}>
                <Typography variant="body">
                  Forgot Password ?{" "}
                  <Button
                    variant="text"
                    sx={{ textTransform: "capitalize" }}
                    onClick={resetPassword}
                  >
                    Reset Now
                  </Button>
                </Typography>
              </Grid>

              <Grid item sx={{ mt: 2 }}>
                <Button
                  type="submit"
                  variant="contained"
                  sx={{
                    height: "60px",
                    width: "160px",
                    background: "primary",
                    borderRadius: "20px",
                    fontSize: "25px",
                    lineHeight: "37px",
                    color: "white",
                    "@media(max-width:900px)": {
                      width: "150px",
                      height: "40px",
                    },
                  }}
                >
                  <Typography
                    variant="body1"
                    color="white"
                    lineHeight="37px"
                    fontSize="25px"
                    textTransform={"capitalize"}
                  >
                    Login
                  </Typography>
                </Button>
              </Grid>
            </Grid>
          </Box>
        </Grid>
      </Grid>
      <PopupModal
        open={userModal}
        handleClose={() => {
          setUserModal(false);
          setFormValue({ email: "", password: "", role: "" });
        }}
        title={<><img style={{width:'180px', height:'40px',marginLeft:'160px'}} src='/icons/oneAndroLogo.png' /> </>}
        modalContent={
          <div class="p-1">
            <span className="fw-600">
              {" "}
              For RMS login, please use the OneAndro portal:
            </span>
            <a
              className="portal-link"
              href="https://crm.oneandro.com"
              target="_blank"
              rel="noopener noreferrer"
            >
              <span className="portal-icon">▰</span>
              OneAndro CRM by Andromeda | Digital Platform for Loan Partners
            </a>
            <h4 style={{ marginTop: "10px" }}>Steps to Access RMS:</h4>{" "}
            <ol>
              {" "}
              <li className="mtb-1">
                {" "}
                Open the OneAndro portal using the link above.{" "}
              </li>
              <li className="mtb-1">
                {" "}
                Enter your registered mobile number and click on{" "}
                <span className="fw-600">Get Started</span>.{" "}
              </li>
              <li className="mtb-1">
                {" "}
                Enter the OTP received on your mobile number and click on{" "}
                <span className="fw-600"> Verify </span>to log in.{" "}
              </li>
              <li className="mtb-1">
                {" "}
                Click on the Menu icon in the top-right corner.{" "}
              </li>
              <li className="mtb-1">
                {" "}
                Select RMS and respective role from the menu to access the RMS
                module.{" "}
              </li>{" "}
            </ol>{" "}
          </div>
        }
        modalHeight={"300px"}
        modalWidth={"500px"}

        // href={href}
        // name={name}
      />
    </Grid>
  );
}

export default LoginComponent;
